import { ZoneContext } from './ZoneContext';
import { useContext } from 'react';

export const useZoneContext = () => {
    const context = useContext(ZoneContext);
    if (!context) {
        throw new Error('useZoneContext must be used within a ZoneProvider');
    }
    return context;
};